module.exports = "<bdb-tp-empty-state\n    is-logo=\"true\"\n    type-logo=\"BDBFULL\"\n    btn-right\n    [errTitle]=\"emptyStateData?.title\"\n    err-desc=\"\"\n    [typeImg]=\"emptyStateData?.imageType\"\n    show-icon\n    label-btn=\"Volver al inicio\"\n    desc=\"Todos Los Derechos Reservados. {{ year }} © Banco de Bogotá.\"\n    (btnClick)=\"handleClick()\"\n>\n    <span slot=\"error-desc\" [innerHTML]=\"description\"></span>\n</bdb-tp-empty-state>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bdb-error-v2/bdb-error-v2.component.html
// module id = ./src/app/bdb-error-v2/bdb-error-v2.component.html
// module chunks = main